import { ReturnDisbursementStatus } from "@redotech/crdb-enums/returns/return-disbursement-status";
import { REFUND_DESTINATION_PROVIDERS } from "@redotech/redo-return-core-common/third-party-refunds/recipient";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

/**
 * Where a Redo-funded refund is headed. Lives in CockroachDB rather than on the
 * return document, so the return page reads it separately.
 */
export const returnRefundDestinationSchema = z.object({
  provider: createEnum(REFUND_DESTINATION_PROVIDERS),
  recipient: z.object({
    email: z.string().nullable(),
    phone: z.string().nullable(),
  }),
  status: createEnum(ReturnDisbursementStatus),
  /** False once a payout is in flight or has landed. */
  canEdit: z.boolean(),
});

export type ReturnRefundDestination = z.infer<
  typeof returnRefundDestinationSchema
>;

export const getReturnRefundDestination = {
  name: "getReturnRefundDestination" as const,
  input: z.object({ returnId: z.string() }),
  /** Null when the return never took a wallet rail. */
  output: z.object({ destination: returnRefundDestinationSchema.nullable() }),
};
